<template>
  <div class="space-y-6">
    <h3 class="text-xl font-bold text-gray-900 pb-2 border-b border-gray-100">
      Add a Tip
    </h3>
    <div class="grid grid-cols-3 sm:grid-cols-5 gap-3">
      <button
        v-for="pct in [15, 18, 20, 25]"
        :key="pct"
        @click="$emit('update:tipOption', pct)"
        :class="[
          'py-3 px-2 rounded-xl border-2 flex flex-col items-center justify-center transition-all',
          tipOption === pct
            ? 'border-primary-600 bg-primary-50 text-primary-700 shadow-sm'
            : 'border-gray-100 hover:border-primary-200 hover:bg-gray-50 text-gray-600'
        ]"
      >
        <span class="font-bold text-lg">{{ pct }}%</span>
        <span class="text-xs font-medium opacity-80">
          {{ formatPrice(subtotal * (pct / 100)) }}
        </span>
      </button>
      <button
        @click="$emit('update:tipOption', 'custom')"
        :class="[
          'py-3 px-2 rounded-xl border-2 flex flex-col items-center justify-center transition-all',
          tipOption === 'custom'
            ? 'border-primary-600 bg-primary-50 text-primary-700 shadow-sm'
            : 'border-gray-100 hover:border-primary-200 hover:bg-gray-50 text-gray-600'
        ]"
      >
        <span class="font-bold text-lg">Other</span>
        <span class="text-xs font-medium opacity-80">Custom</span>
      </button>
    </div>

    <div v-if="tipOption === 'custom'" class="fadeIn-0-2s relative">
      <DollarSign
        :size="18"
        class="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
        style="transform: translateY(-50%);"
      />
      <input
        type="number"
        :value="customTip"
        @input="$emit('update:customTip', $event.target.value)"
        placeholder="Enter tip amount"
        class="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-primary-500 outline-none transition-all font-bold text-gray-900"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CheckoutTipSection",
  props: {
    subtotal: {
      type: Number,
      required: true
    },
    tipOption: {
      type: [Number, String],
      required: true
    },
    customTip: {
      type: [String, Number],
      default: ""
    }
  },
  computed: {
    ...mapGetters(["formatPrice"])
  }
};
</script>
